import type { UserRole } from "../types/domain";

export const superiorContentRoles: UserRole[] = [
  "super_admin",
  "municipal_admin",
  "mayor",
  "general_secretary",
  "system_admin",
];

export const designManagerRoles: UserRole[] = [...superiorContentRoles, "designer"];

export const newsManagerRoles: UserRole[] = [...superiorContentRoles, "news_editor"];

export const institutionManagerRoles: UserRole[] = [...superiorContentRoles];

export const contentManagerRoles: UserRole[] = [
  ...new Set([...designManagerRoles, ...newsManagerRoles, ...institutionManagerRoles]),
];

export function hasAnyRole(current: UserRole[], allowed: UserRole[]): boolean {
  return current.some((role) => allowed.includes(role));
}
